<template>
  <div class="border rounded">
    <div
      v-for="(button, index) in buttons"
      :key="index"
      class="cursor-pointer"
      :class="{
        'border-bottom': buttons.length > 1 && index !== buttons.length - 1
      }"
      @click="button.click"
    >
      <div
        class="px-4 py-3 d-flex justify-start"
        :class="button.textColor ? `${button.textColor}--text` : null"
      >
        <div class="mr-4">
          <v-img
            v-if="button.img"
            width="24"
            contain
            :src="$asset(`img/icons/${button.img}.svg`)"
          />
          <v-icon v-else-if="button.icon" size="24" :color="button.color || 'black'">
            {{ button.icon }}
          </v-icon>
        </div>
        <div>{{ button.text }}</div>
        <div class="ml-auto rotate-270">
          <v-icon size="24" :color="button.textColor || null"> $dropSmall </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileButtonGroup',
  props: {
    buttons: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: $border-width solid $grey-lighten !important;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    bottom: -$border-width;
    left: 0;
    width: 56px;
    height: $border-width;
    background-color: $white;
  }
}
</style>
